import {deleteSite} from '@/api/sites';
import {useMutation, useQueryClient} from '@tanstack/react-query';

export function useDeleteSite() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (siteId: string) => deleteSite(siteId),
        onSuccess: (_result, siteId) => {
            queryClient.invalidateQueries({queryKey: ['sites']});
            queryClient.invalidateQueries({queryKey: ['site', siteId]});
        }
    });
}
